import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, ReferenceLine, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 参考线列表 */
    referenceLines: ReferenceLine[];
    /** 鼠标速度 */
    mouseSpeed: number;
}

/** 动作 */
interface IAction {
    /** 设置参考线 */
    setReferenceLines: (referenceLines: ReferenceLine[]) => void;
    /** 设置鼠标速度 */
    setMouseSpeed: (speed: number) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        referenceLines: [],

        setReferenceLines(lines) {
            set({ referenceLines: lines });
        },
        mouseSpeed: 0,
        setMouseSpeed(speed) {
            set({ mouseSpeed: speed });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'mouse-operate-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useMouseOperateState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getMouseOperateState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
